/* eslint-disable array-callback-return */
import React, { FC, useCallback, useEffect } from "react"
import { Redirect, Route, Switch } from "react-router"
import { useRecoilValue } from "recoil"
import { AdminDashboard, ProductDetail, ProductDetailDashboard } from "../component/Admin"
import ImportJobDetail from "../component/Admin/import-inventory/ImportJobDetail"
import { DistributorDashboard, DistributorOrderEdit, DistributorOrderInfo, DistributorInventoryDetail } from "../component/Distributor"
import { FormProduct, InventoryOfPharmacy, SearchProduct, InventoryDashboard } from "../component/Pharmacys"
import { FormProductPage } from "../component/Pharmacys/FormProduct"
import { useAccount } from "../hooks"
import { accountDataState } from "../recoil/account"

interface IRouter {
    path: string,
    exact: boolean,
    component: FC
}

const routers: Array<IRouter> = [
    {
        path: '/',
        exact: true,
        component: () => <Redirect to="/admin-dashboard" />
    },
    {
        path: '/admin-dashboard',
        exact: false,
        component: AdminDashboard
    },
    {
        path: '/search-product',
        exact: false,
        component: SearchProduct
    },
    {
        path: '/update-product',
        exact: false,
        component: FormProductPage
    },
    {
        path: '/import-job-detail',
        exact: false,
        component: ImportJobDetail
    },
    {
        path: '/distributor-dashboard',
        exact: false,
        component: DistributorDashboard
    },
    {
        path: '/distributor-inventory-detail',
        exact: false,
        component: DistributorInventoryDetail
    },
    {
        path: '/distributor-order-info',
        exact: false,
        component: DistributorOrderInfo
    },
    {
        path: '/distributor-order-edit',
        exact: false,
        component: DistributorOrderEdit
    },
    {
        path: '/inventory-dashboard',
        exact: false,
        component: InventoryDashboard
    },
    {
        path: '/product-detail-dashboard',
        exact: false,
        component: ProductDetailDashboard
    },
]

const getPathHasPermissionByRole = (userLocalType: string) => {
    switch (userLocalType) {
        case 'PHARMACIST':
            return [
                "/inventory-dashboard",
                "/search-product",
                "/update-product",
                "/distributor-dashboard",
                "/distributor-inventory-detail",
                "/distributor-order-info",
                "/distributor-order-edit",
            ]
        case 'ADMIN':
            return [
                "/admin-dashboard",
                "/search-pharmacys",
                "/inventory-dashboard",
                "/search-product",
                "/update-product",
                "/import-job-detail",
                "/product-detail-dashboard",
            ]
        default:
            return []
    }
}

const Pharmacys: React.FC = React.memo(() => {
    const account = useRecoilValue(accountDataState)
    const { clearFlowForApp } = useAccount()

    useEffect(() => {
        return () => {
            clearFlowForApp()
        }
    }, [])

    const checkPermisstion = useCallback((path: string) => {
        let pathHasPermission = getPathHasPermissionByRole(account?.loginSession?.userLocalType)

        if (pathHasPermission.includes(path)) return true
        return false
    }, [account])

    return <Switch>
        {
            routers.map((router: IRouter) => {
                const { path, exact, component } = router
                if (checkPermisstion(path)) {
                    return <Route exact={exact} path={path} component={component} key={path} />
                }
            })
        }
    </Switch>
})

export default Pharmacys